import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
    ecShippingWrapper: {
        maxWidth: "500px",
        height: "min-content",
        "& .ecShippingInfo": {
            fontSize: "13px",
            fontStyle: "italic",
            fontWeight: 300,
            lineHeight: "18px"
        },
        "& .commonButton": { marginTop: "30px" },
        "& .ShippingHeading": { margin: "10px 0" },
        "& .ShippingCost": {
            borderTop: "1px solid var(--blackOpacity10)",
            borderBottom: "1px solid var(--blackOpacity10)",
            padding: "10px 0",
            margin: "10px 0"
        },
        "& .ecFlexSpaceWrapper": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "20px",
            "& .subInnerHeadingPara": { fontSize: "14px" }
        },
    }
})